module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABVklEQVQ4jZ3Sv0tVcRjH8VcpCQlqJG2CcLmL/QO2SBHEzUVxkBbBKRpEkXSoIVraGqKhqBwTFAwEbb2LkIi4urRpGOGgtTQUGt94DhxO94inz3Y+z/N9n+fXheEXe9CJOdzCMhbwSwW14xIe4Gl4N3ANz/D7vKCLuIPnOS+BpzBWpaIEetTC78UsuqqAuktiPahXAX1u4e/jJXaqgFYK3hdM4vV5IRnoI74VqmlWgWSg73iS865j/n9Ap3iP7fC6YpOjVUFJPzGDr/F9BW9wt+Rdd9zbP6BU1WbcTqZ03W9xrwAZwhLWMZGZbfVG/q1dHKCRYtHmTVzGBmp4FV4toCmn2V7422lUkVp9h4648scBT48GcvlXYzFHRVCmRRzHUfbHPAZLclPsYTajok6whnFsleTk9akMlCmdRNrcNA7PqP5+WWt5HcWAP2AEt9EX81z9G+PHH0HtPVBqnfXVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_tel.png
// module id = JuyH
// module chunks = 3